import { set, keyBy } from 'lodash/fp';
import createReducer from '../../../helpers/createReducer';
import { fetchHouseholdMemberColumns } from '../../sagas/household-member-column/routines';

const initialState = {
  columnsByName: {},
  fetched: false,
  fetching: false,
  fetchingError: null
};

export const fetchColumnsHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(`columnsByName`, keyBy('name', response.items), state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchColumnsHandler(fetchHouseholdMemberColumns)
});
